import ModelCarView from './ModelCarView'
export default ModelCarView;
